// extracted by mini-css-extract-plugin
export default {"input":"Textarea_input__k6NT2","visibleIndicator":"Textarea_visibleIndicator__4MKvY","passwordInput":"Textarea_passwordInput__RX3CH","boxRow":"Textarea_boxRow__-U29Q"};